(function() {
    'use strict';

    angular
        .module('serviciosocialApp')
        .controller('NavbarController', NavbarController);

    NavbarController.$inject = ['$state', 'Auth', 'Principal', 'ProfileService', 'LoginService', 'ReporteModalService'];

    function NavbarController ($state, Auth, Principal, ProfileService, LoginService, ReporteModalService) {
        var vm = this;

        vm.isNavbarCollapsed = true;
        vm.isAuthenticated = Principal.isAuthenticated;

        ProfileService.getProfileInfo().then(function(response) {
            vm.inProduction = response.inProduction;
            vm.swaggerEnabled = response.swaggerEnabled;
        });

        vm.login = login;
        vm.logout = logout;
        
        vm.proyectosAprobadosPorModalidad = proyectosAprobadosPorModalidad;
        vm.proyectosAprobadosPorModalidadFac = proyectosAprobadosPorModalidadFac;
        vm.proyectosAprobadosPorPerfilModalidad = proyectosAprobadosPorPerfilModalidad;
        vm.proyectosAprobadosPorPerfilModalidadFac = proyectosAprobadosPorPerfilModalidadFac;
        vm.proyectosPorDependenciaModalidadTipo = proyectosPorDependenciaModalidadTipo;
        vm.proyectosAprobadosPorArea = proyectosAprobadosPorArea;
        vm.proyectosAprobadosPorFuncion = proyectosAprobadosPorFuncion;
        vm.proyectosAprobadosConApoyoEconomico = proyectosAprobadosConApoyoEconomico;
        vm.proyectosAprobadosConApoyoEconomicoFac = proyectosAprobadosConApoyoEconomicoFac;
        vm.proyectosAprobadosPorDependenciaVigencia = proyectosAprobadosPorDependenciaVigencia;
        vm.directorioDependencias = directorioDependencias;
        vm.prestadoresPorPerfil = prestadoresPorPerfil;
        vm.plazasDisponiblesAll = plazasDisponiblesAll;
        vm.plazasDisponibles = plazasDisponibles;
        vm.plazasDisponiblesByFac = plazasDisponiblesByFac;
        vm.prestadoresPorPerfilFac = prestadoresPorPerfilFac;
        vm.prestadoresPorDependenciaProyecto = prestadoresPorDependenciaProyecto;
        vm.bajasPrestadores = bajasPrestadores;
        vm.bajasPrestadoresFac = bajasPrestadoresFac;
        vm.proyectosPorPeriodo = proyectosPorPeriodo;
        
        vm.toggleNavbar = toggleNavbar;
        vm.collapseNavbar = collapseNavbar;
        vm.$state = $state;

        function login() {
            collapseNavbar();
            LoginService.open();
        }

        function logout() {
            collapseNavbar();
            Auth.logout();
            $state.go('home');
        }
        
        function proyectosAprobadosPorModalidad() {
            collapseNavbar();
            ReporteModalService.proyectosAprobadosPorModalidad();
        }
        
        function proyectosAprobadosPorModalidadFac() {
            collapseNavbar();
            ReporteModalService.proyectosAprobadosPorModalidadFac();
        }

        function proyectosAprobadosPorPerfilModalidad() {
            collapseNavbar();
            ReporteModalService.proyectosAprobadosPorPerfilModalidad();
        }
        
        function proyectosAprobadosPorPerfilModalidadFac() {
            collapseNavbar();
            ReporteModalService.proyectosAprobadosPorPerfilModalidadFac();
        }
                
        function proyectosPorDependenciaModalidadTipo() {
            collapseNavbar();
            ReporteModalService.proyectosPorDependenciaModalidadTipo();
        }

        function proyectosAprobadosPorArea() {
            collapseNavbar();
            ReporteModalService.proyectosAprobadosPorArea();
        }

        function proyectosAprobadosPorFuncion() {
            collapseNavbar();
            ReporteModalService.proyectosAprobadosPorFuncion();
        }
        
        function proyectosAprobadosConApoyoEconomico() {
            collapseNavbar();
            ReporteModalService.proyectosAprobadosConApoyoEconomico();
        }
        
        function proyectosAprobadosConApoyoEconomicoFac() {
            collapseNavbar();
            ReporteModalService.proyectosAprobadosConApoyoEconomicoFac();
        }

        function proyectosAprobadosPorDependenciaVigencia() {
            collapseNavbar();
            ReporteModalService.proyectosAprobadosPorDependenciaVigencia();
        }
        
        function directorioDependencias() {
            collapseNavbar();
            ReporteModalService.directorioDependencias();
        }

        function prestadoresPorPerfil() {
            collapseNavbar();
            ReporteModalService.prestadoresPorPerfil();
        }
        
        function plazasDisponiblesAll() {
            collapseNavbar();
            ReporteModalService.plazasDisponiblesAll();
        }
        
        function plazasDisponibles() {
            collapseNavbar();
            ReporteModalService.plazasDisponibles();
        }
        
        function plazasDisponiblesByFac() {
            collapseNavbar();
            ReporteModalService.plazasDisponiblesByFac();
        }
        
        function prestadoresPorPerfilFac() {
            collapseNavbar();
            ReporteModalService.prestadoresPorPerfilFac();
        }

        function prestadoresPorDependenciaProyecto() {
            collapseNavbar();
            ReporteModalService.prestadoresPorDependenciaProyecto();
        }

        function bajasPrestadores() {
            collapseNavbar();
            ReporteModalService.bajasPrestadores();
        }
        
        function bajasPrestadoresFac() {
            collapseNavbar();
            ReporteModalService.bajasPrestadoresFac();
        }
        
        function proyectosPorPeriodo() {
            collapseNavbar();
            ReporteModalService.proyectosPorPeriodo();
        }
        
        function toggleNavbar() {
            vm.isNavbarCollapsed = !vm.isNavbarCollapsed;
        }

        function collapseNavbar() {
            vm.isNavbarCollapsed = true;
        }
    }
})();
